"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tabs = exports.TabPanels = exports.TabPanel = exports.TabList = exports.Tab = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _Icon = require("../svg/Icon");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var Tabs = /*#__PURE__*/function (_React$Component) {
  _inherits(Tabs, _React$Component);
  var _super = _createSuper(Tabs);
  function Tabs() {
    _classCallCheck(this, Tabs);
    return _super.apply(this, arguments);
  }
  _createClass(Tabs, [{
    key: "render",
    value: function render() {
      var tabData = _react.default.Children.toArray(this.props.children);
      var tabClass = this.props.tabClass ? this.props.tabClass + " row tab-shwocase" : "row tab-shwocase";
      var TabPanelClass = this.props.TabPanelClass ? this.props.TabPanelClass + " row" : "row";
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: tabClass
      }, tabData[0]), /*#__PURE__*/_react.default.createElement("div", {
        className: TabPanelClass
      }, tabData[1]));
    }
  }]);
  return Tabs;
}(_react.default.Component);
exports.Tabs = Tabs;
var TabPanels = /*#__PURE__*/function (_React$Component2) {
  _inherits(TabPanels, _React$Component2);
  var _super2 = _createSuper(TabPanels);
  function TabPanels() {
    var _this;
    _classCallCheck(this, TabPanels);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super2.call.apply(_super2, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "renderTab", function (tabData) {
      if (_this.props.selectedTabId) {
        var content = tabData.find(function (item) {
          return item.props.id === _this.props.selectedTabId;
        });
        if (content) {
          content = /*#__PURE__*/(0, _react.cloneElement)(content, {
            active: true
          });
        }
        return content;
      }
      return tabData;
    });
    return _this;
  }
  _createClass(TabPanels, [{
    key: "render",
    value: function render() {
      var tabData = _react.default.Children.toArray(this.props.children);
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "body16 tl-tab-contents tl-ui"
      }, this.renderTab(tabData));
    }
  }]);
  return TabPanels;
}(_react.default.Component);
exports.TabPanels = TabPanels;
var TabPanel = /*#__PURE__*/function (_React$Component3) {
  _inherits(TabPanel, _React$Component3);
  var _super3 = _createSuper(TabPanel);
  function TabPanel() {
    _classCallCheck(this, TabPanel);
    return _super3.apply(this, arguments);
  }
  _createClass(TabPanel, [{
    key: "render",
    value: function render() {
      var _this$props$id;
      var classVal = 'tabcontent ';
      if (this.props.className) {
        classVal += this.props.className;
      }
      if (this.props.name) {
        classVal += ' ' + this.props.name;
      }
      if (this.props.active) {
        classVal += " tabcontent-active ";
      }
      var tabId = (_this$props$id = this.props.id) === null || _this$props$id === void 0 ? void 0 : _this$props$id.replace(/-(\d+)$/, '$1');
      return /*#__PURE__*/_react.default.createElement("div", {
        role: "tabpanel",
        "aria-labelledby": tabId,
        className: classVal,
        id: this.props.id
      }, this.props.children);
    }
  }]);
  return TabPanel;
}(_react.default.Component);
exports.TabPanel = TabPanel;
var Tab = /*#__PURE__*/function (_React$Component4) {
  _inherits(Tab, _React$Component4);
  var _super4 = _createSuper(Tab);
  function Tab() {
    var _this2;
    _classCallCheck(this, Tab);
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    _this2 = _super4.call.apply(_super4, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this2), "handleKeyDown", function (e) {
      if (['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(e.key)) {
        e.preventDefault();
        var node = e.target;
        var numTabs = node.parentElement.children.length;
        var index = Array.from(node.parentElement.children).indexOf(node);
        var direction = e.key === 'ArrowRight' ? 1 : -1;
        var newIndex = index + direction;
        switch (e.key) {
          case 'ArrowRight':
            newIndex = newIndex < numTabs ? newIndex : numTabs - 1;
            break;
          case 'ArrowLeft':
            newIndex = newIndex >= 0 ? newIndex : 0;
            break;
          case 'Home':
            newIndex = 0;
            break;
          case 'End':
            newIndex = numTabs - 1;
            break;
          default:
            break;
        }
        var newFocus = node.parentElement.children[newIndex];
        newFocus.focus();
      }
    });
    _defineProperty(_assertThisInitialized(_this2), "getClassVal", function () {
      var classVal = 'tablist-item';
      if (_this2.props.className) {
        classVal += ' ' + _this2.props.className;
      }
      if (_this2.props.active) {
        classVal += " tab-active ";
      }
      if (_this2.props.disabled) {
        classVal = classVal + ' tab-disabled';
      }
      if (_this2.props.name) {
        classVal = classVal + ' ' + _this2.props.name;
      }
      return classVal;
    });
    return _this2;
  }
  _createClass(Tab, [{
    key: "handleTabClick",
    value: function handleTabClick(e, className, classNamePanel) {
      var activeClasses = '';
      var tabContent = '';
      var node = e.target;
      var tabId = node.id;
      var tabLinkClass = '.' + className + '.tab-active';
      var tabPanelClass = '.' + classNamePanel + '.tabcontent-active';
      if (className && className !== undefined) {
        activeClasses = document.querySelectorAll(tabLinkClass)[0];
        tabContent = document.querySelectorAll(tabPanelClass)[0];
      } else {
        activeClasses = document.querySelector('.tab-active');
        tabContent = document.querySelector('.tabcontent-active');
      }
      if (activeClasses) {
        activeClasses.classList.remove('tab-active');
      }
      node.classList.add('tab-active');
      node.setAttribute('aria-selected', 'true');
      node.setAttribute('tabIndex', '0');
      if (tabContent) {
        tabContent.classList.remove('tabcontent-active');
      }
      var list = this.getAllSiblings(node, node.parentElement);
      list.forEach(function (node) {
        node.setAttribute('aria-selected', 'false');
        node.setAttribute('tabIndex', '-1');
      });
      var tabContentId = tabId.replace(/(\d)/g, '-$1');
      var tabContentDivShow = document.querySelector("".concat('#' + tabContentId));
      if (tabContentDivShow) {
        tabContentDivShow.classList.add('tabcontent-active');
      }
      if (this.props.onClick) {
        this.props.onClick(tabId, tabContentId, e);
      }
    }
  }, {
    key: "getAllSiblings",
    value: function getAllSiblings(element, parent) {
      var children = _toConsumableArray(parent.children);
      return children.filter(function (child) {
        return child !== element;
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$id2,
        _this3 = this;
      var classVal = this.getClassVal();
      var tabUrl = this.props.tabUrl ? this.props.tabUrl : "#";
      var tabContentId = (_this$props$id2 = this.props.id) === null || _this$props$id2 === void 0 ? void 0 : _this$props$id2.replace(/(\d)/g, '-$1');
      return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
        role: "tab",
        tabIndex: this.props.active ? 0 : -1,
        "aria-selected": this.props.active ? 'true' : 'false',
        "aria-controls": tabContentId,
        to: tabUrl,
        className: classVal,
        id: this.props.id,
        onClick: function onClick(e) {
          return _this3.handleTabClick(e, _this3.props.name, _this3.props.panelName);
        },
        onKeyDown: function onKeyDown(e) {
          return _this3.handleKeyDown(e);
        }
      }, this.props.iconName ? /*#__PURE__*/_react.default.createElement(_Icon.SvgIcon, {
        className: "tl-svg-info-icon",
        name: this.props.iconName
      }) : '', this.props.children);
    }
  }]);
  return Tab;
}(_react.default.Component);
exports.Tab = Tab;
var TabList = /*#__PURE__*/function (_React$Component5) {
  _inherits(TabList, _React$Component5);
  var _super5 = _createSuper(TabList);
  function TabList() {
    var _this4;
    _classCallCheck(this, TabList);
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }
    _this4 = _super5.call.apply(_super5, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this4), "renderTab", function (tabData) {
      return tabData.map(function (item, key) {
        return item;
      });
    });
    return _this4;
  }
  _createClass(TabList, [{
    key: "render",
    value: function render() {
      var classVal = this.props.className ? this.props.className + " tl-tab-container tl-ui" : "tl-tab-container tl-ui";
      var tabData = _react.default.Children.toArray(this.props.children);
      return /*#__PURE__*/_react.default.createElement("div", {
        className: classVal,
        id: "tab-container"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "tablist",
        role: "tablist",
        "aria-label": this.props.label,
        "aria-labelledby": this.props.labelledby
      }, this.renderTab(tabData)));
    }
  }]);
  return TabList;
}(_react.default.Component);
exports.TabList = TabList;